import axios, {AxiosInstance, AxiosRequestConfig} from 'axios';

import {FUNCTIONS_URL, IS_DEV_MODE} from '~/modules/config';

export class APIError extends Error {
  statusCode: number;

  constructor(message: string, {statusCode}: {statusCode: number}) {
    super(message);
    this.statusCode = statusCode;
  }
}

export class API {
  private axiosInstance: AxiosInstance;
  private authToken: string = '';

  constructor() {
    this.axiosInstance = this.createAxiosInstance();
  }

  createAxiosInstance() {
    return axios.create({
      baseURL: `${FUNCTIONS_URL}/adminApi`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.authToken}`,
      },
    });
  }

  setAuthToken(authToken: string) {
    if (IS_DEV_MODE) {
      console.log('[api] setAuthToken', authToken);
    }
    this.authToken = authToken;
    this.axiosInstance = this.createAxiosInstance();
  }

  async fetch(config: AxiosRequestConfig) {
    if (IS_DEV_MODE) {
      console.log('[api] fetch', config);
    }
    const response = await this.axiosInstance.request(config);
    if (response.status === 200) {
      return response;
    } else {
      throw new APIError(response.data?.errorMessage ?? response.statusText, {
        statusCode: response.status,
      });
    }
  }
}
